import {
  NumberInput as ChakraNumberInput,
  Field,
  InputGroup,
  NumberInputRootProps,
} from '@chakra-ui/react'
import { ReactElement, ReactNode } from 'react'
import { InputContainer, InputContainerProps } from '.'

export interface Props
  extends Omit<NumberInputRootProps, 'children' | 'value' | 'onChange' | 'onValueChange'> {
  value?: number
  onChange?: (value: number) => void
  placeholder?: string
  rightElement?: ReactElement
  label?: ReactNode
  inputContainerProps?: Omit<InputContainerProps, 'label' | 'children'>
  isError?: boolean
}

export default function NumberInput({
  value,
  onChange,
  placeholder,
  rightElement,
  label,
  inputContainerProps,
  isError,
  width,
  ...rest
}: Props) {
  return (
    <Field.Root alignItems="stretch" width={width}>
      <InputContainer label={label} isError={isError} {...inputContainerProps}>
        <ChakraNumberInput.Root
          value={value?.toString()}
          onValueChange={v => onChange?.(v.valueAsNumber)}
          borderRadius="sm"
          boxShadow="0px 1px 4px 0px rgba(0, 0, 0, 0.06)"
          {...rest}
        >
          <InputGroup endElement={rightElement} endElementProps={{ p: 0 }}>
            <ChakraNumberInput.Input placeholder={placeholder} />
          </InputGroup>
          <ChakraNumberInput.Control>
            <ChakraNumberInput.IncrementTrigger />
            <ChakraNumberInput.DecrementTrigger />
          </ChakraNumberInput.Control>
        </ChakraNumberInput.Root>
      </InputContainer>
    </Field.Root>
  )
}
